import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSpinner} from '@fortawesome/free-solid-svg-icons';

interface LoadingSpinnerProps {
    fullScreen?: boolean;
    message?: string;
    size?: 'sm' | 'md' | 'lg';
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
                                                                  fullScreen = true,
                                                                  message = 'Đang tải thông tin...',
                                                                  size = 'md'
                                                              }) => {
    // Toàn màn hình thì phải mang luôn nền gradient của app: đây là thứ hiện ra
    // trong lúc kiểm tra đăng nhập và trong lúc tải chunk của trang, mà trước đây
    // nó là một mảng xám trơn - nhìn như trang lỗi chứ không như app đang mở.
    const containerClasses = fullScreen
        ? "min-h-app lg-app-bg"
        : "min-h-[200px]";

    const sizeClasses = {
        sm: 'text-lg',
        md: 'text-2xl',
        lg: 'text-4xl'
    };

    const textSizeClasses = {
        sm: 'text-sm',
        md: 'text-base',
        lg: 'text-lg'
    };

    return (
        <div 
            className={`flex items-center justify-center ${containerClasses} animate-fade-in`}
            role="status"
            aria-live="polite"
            aria-busy="true"
        >
            <div className="flex flex-col items-center space-y-3">
                <div className="relative">
                    <FontAwesomeIcon
                        icon={faSpinner}
                        className={`animate-spin text-slate-500 dark:text-slate-400 ${sizeClasses[size]}`}
                        aria-hidden="true"
                    />
                </div>
                {message && (
                    <span className={`text-slate-600 dark:text-slate-300 ${textSizeClasses[size]} animate-pulse-soft`}>
                        {message}
                    </span>
                )}
                <span className="sr-only">Đang tải...</span>
            </div>
        </div>
    );
};